/* This file is autogenerated, see readme.md for instructions */
import UploadSvgIcon from '@bloomreach/banana-theme/icons/upload.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const UploadIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <UploadSvgIcon />
    </Icon>
  );
});

UploadIcon.displayName = 'UploadIcon';

export default UploadIcon;
